import {IconButton} from '@mui/material';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap';

type FullScreenButtonProps = {
    isFullScreen: boolean;
    setIsFullScreen: (isFullScreen: boolean) => void;
    size?: 'small' | 'medium' | 'large';
};

export const FullScreenButton = ({
    isFullScreen,
    setIsFullScreen,
    size = 'medium',
}: FullScreenButtonProps) => {
    return (
        <IconButton
            onClick={() => {
                setIsFullScreen(!isFullScreen);
            }}
            size={size}
        >
            {isFullScreen ? <ZoomInMapIcon /> : <ZoomOutMapIcon />}
        </IconButton>
    );
};
